module.exports = __webpack_public_path__ + "assets/boxicons.ac68c5bee58c439e4c2851555d41be8b.svg";